import { Tab, Tabs, Typography } from "@mui/material";
import React from "react";
import { BlockOptionLayouts } from "../../helpers/blocks";
import { DraggableBlockOption } from "shared/components/BlockOption/DraggableBlockOption";
import { ExistingBlocks } from "modules/ExistingBlocks/components/ExistingBlocks";
import { MainSurveyStore } from "../../hooks/useMainSurvey";

const TabOptions = {
  NEW: "New blocks",
  Existing: "Existing blocks",
};

export const BlockSelection = (props: BlockSectionProps) => {
  const { mainSurveyStore } = props;
  const [selectedTab, setSelectedTab] = React.useState<string>(TabOptions.NEW);

  return (
    <div className="layout-block-selection">
      <Tabs value={selectedTab} onChange={(e, value) => setSelectedTab(value)} aria-label="basic tabs example">
        <Tab value={TabOptions.NEW} label={TabOptions.NEW} />
        <Tab value={TabOptions.Existing} label={TabOptions.Existing} />
      </Tabs>

      <div className="selection-section">
        {selectedTab === TabOptions.NEW && (
          <div className="new-options-container">
            {BlockOptionLayouts.map((optionsSection) => (
              <div key={optionsSection.type} className="options-section">
                <Typography variant="h4" color="text.secondary">
                  {optionsSection.type}
                </Typography>
                {optionsSection.options.map((option) => (
                  <DraggableBlockOption
                    key={option.blockType}
                    onDragStart={() => mainSurveyStore.setNewBlockTypeToBeAdded(option.blockType)}
                    onDragEnd={() => mainSurveyStore.setNewBlockTypeToBeAdded(null)}
                    blockType={option.blockType}
                  />
                ))}
              </div>
            ))}
          </div>
        )}

        {selectedTab === TabOptions.Existing && <ExistingBlocks mainSurveyStore={mainSurveyStore} />}
      </div>
    </div>
  );
};

interface BlockSectionProps {
  mainSurveyStore: MainSurveyStore;
}
